import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { Timer } from "./Timer";

export class HUD extends Phaser.Group {

    private fpsLabel: Phaser.Text;
    private timer: Timer;
    
    constructor(game: Phaser.Game) {
        
        super(game, null, "hud");
        
        this.timer = new Timer(this.game);
        this.add(this.timer);
        
        const labelsContainer = new Phaser.Group(this.game);
        labelsContainer.x = GameConstants.GAME_WIDTH / 2;
        labelsContainer.scale.x = GameVars.scaleX;
        this.add(labelsContainer);
        
        if (GameConstants.DEVELOPMENT) {
            this.fpsLabel = new Phaser.Text(this.game, 18, 130, "0", { font: "24px Arial", fill: "#ffffff"});
            this.fpsLabel.scale.x = GameVars.scaleX;
            this.add(this.fpsLabel);
        } else {
            this.fpsLabel = null;
        }
    }
    
    public update(): void {
        
        super.update();
        
        if (GameConstants.DEVELOPMENT) {
            this.fpsLabel.text = "fps: " + this.game.time.fps;
        }
    }
    
    public resizeFullScreen(): void {
            
        this.timer.scale.x = GameVars.scaleX;
    }
    
    public startTimer(): void {
        
        this.timer.start();
    }
    
    public pause(): void {
        
        this.timer.pause();
        
        if (this.fpsLabel) {
            this.fpsLabel.visible = false;
        } 
    }
    
    public resume(): void {
        
        this.timer.resume();
        
        if (this.fpsLabel) {
            this.fpsLabel.visible = true;
        }
    }
}
